<div class="partners-info">
  <span class="partners-info__text">{{text | translate}}</span>
  <div class="partners-info__references">
    @for (partner of partnersList; track partner) {
      <div class="partners-info__partner">
        <a href="{{partner.link}}" target="_blank">
          <figure>
            <img  src="{{partner.logo}}" alt="alt">
          </figure>
        </a>
      </div>
    }
  </div>
</div>